import { render, staticRenderFns } from "./PurchaseEditVat.vue?vue&type=template&id=034c5781&scoped=true"
import script from "./PurchaseEditVat.vue?vue&type=script&lang=ts"
export * from "./PurchaseEditVat.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseEditVat.vue?vue&type=style&index=0&id=034c5781&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c5781",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034c5781')) {
      api.createRecord('034c5781', component.options)
    } else {
      api.reload('034c5781', component.options)
    }
    module.hot.accept("./PurchaseEditVat.vue?vue&type=template&id=034c5781&scoped=true", function () {
      api.rerender('034c5781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseEditVat.vue"
export default component.exports